import classNames from "classnames";
import { gql, useQuery } from "@apollo/client";
import wpClient from "../../../../ugg/src/lib/wp-client";
import { SvgMiscMegaphone } from "@ugitgud/legos/ui/icon/SVG/MiscMegaphone";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";

type StickyNewsBannerProps = {
  className?: string;
  showWhileLoading?: boolean;
  suppressErrors?: boolean;
};

const GET_TIER_LIST_NEWS_BANNER = gql`
  query getMainSiteOptions {
    mainSiteOptions {
      mainSiteOptions {
        tierListStickyLabelIconBorderColor
        tierListStickyUrl
      }
    }
  }
`;

function useTierListNewsBanner() {
  const { data, loading, error } = useQuery(GET_TIER_LIST_NEWS_BANNER, { client: wpClient });
  return { opts: data?.mainSiteOptions?.mainSiteOptions, loading, error };
}

export function PatchNotesCTAButton() {
  const { opts } = useTierListNewsBanner();
  const url = opts?.tierListStickyUrl;
  const color = opts?.tierListStickyLabelIconBorderColor as string | undefined;

  if (!url) return null;

  return (
    <a
      href={url}
      style={{ borderColor: color, color }}
      className="relative top-[2px] flex items-center justify-center gap-2 w-[174px] h-[36px] bg-black border rounded-[3px] font-['Inter'] text-[14px] font-extrabold shrink-0"
    >
      <Icon icon={<SvgMiscMegaphone />} className="w-4 h-4 text-white" />
      View Patch Notes
    </a>
  );
}

export default function StickyNewsBanner({ className, showWhileLoading = false, suppressErrors = true }: StickyNewsBannerProps) {
  const { opts, loading, error } = useTierListNewsBanner();

  if (loading && !showWhileLoading) return null;
  if (error && suppressErrors) return null;

  const url = opts?.tierListStickyUrl;

  if (!url) return null;

  const color = opts?.tierListStickyLabelIconBorderColor as string | undefined;

  return (
    <a
      href={url}
      className={classNames(
        "flex items-center justify-center gap-3 w-full rounded-[6px] bg-black my-[36px] py-[9px] px-[18px]",
        className,
      )}
      style={{ border: color ? `1px solid ${color}` : undefined }}
    >
      <Icon icon={<SvgMiscMegaphone />} className="w-5 h-5 text-white" />
      <span className="font-extrabold text-[14px] leading-6" style={{ color }}>
        View Patch Notes
      </span>
    </a>
  );
}
